export default __webpack_public_path__ + "static/media/landing.e72dfdc2.jpg";